class Node {}

export { Node };
